import Resource from '@/api/resources/Resource'

class GenderConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/genders`, filterModel, { params })
        return response.data
    }
    async getGendersByName(params) {
        const response = await this.axios.get(`/configuration/genders/search`, { params })
        return response.data
    }
    async patchGendersBatch(genders) {
        const response = await this.axios.patch(`/configuration/genders/batch`, genders)
        return response.data
    }
    async createGender(gender) {
        const response = await this.axios.post(`/configuration/genders`, gender)
        return response.data
    }
    async deleteGendersBatch(genders) {
        const data = {
            entityIdentifiers: genders
        }
        const response = await this.axios.delete(`/configuration/genders/batch`, { data: data })
        return response.data
    }
}

export default new GenderConfigurationServices()
